<script lang="ts">
  import type { IUserTimeStatsEntryDTO } from "../../services/DTO/user-time-stats-entry-dto";

  export let entries: IUserTimeStatsEntryDTO[] = [];
</script>

{#if !!entries}
  {#each entries as entry}
    <div class="columns is-gapless dossier-user-stats-entry">
      <div class="column is-6">
        <progress
          class="progress is-primary is-small"
          value={entry.timePercentage}
          max="100"
          title={entry.timePercentage.toFixed(0) + " %"}
        />
      </div>
      <div class="column is-6">
        <p class="is-size-6 dossier-user-stats-user">{entry.userName}</p>
      </div>
    </div>
  {/each}
{/if}

<style>
  .dossier-user-stats-entry {
    margin-bottom: 0.75rem !important;
  }
  .dossier-user-stats-user {
    line-height: 0.75rem;
    padding-left: 0.5rem;
  }
</style>
